import axiosClient from "../../shared/components/requests/axiosCLient";
import { API_URLS } from "../../shared/constants/constants";

export const getNewsUpdateDetails = (pageSize) => {
  const url = `${API_URLS.trainingVideo}&sort=updatedAt:DESC&pagination[pageSize]=6&pagination[page]=${pageSize}`;
  return axiosClient.get(url);
};

export const getNewsTagDetails = () => {
  const url = API_URLS.trainingVideoTags;
  return axiosClient.get(url);
};

export const queryUpdateDetails = (filterName, pageSize) => {
  const url = `${API_URLS.trainingVideoQueryApi}${filterName}&sort=updatedAt:DESC&pagination[pageSize]=6&pagination[page]=${pageSize}`;
  return axiosClient.get(url);
};

export const getNewsListDetails = () => {
  const url = API_URLS.trainingListingApi;
  return axiosClient.get(url);
};
